var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyesC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 35,
    viewBox: "0 0 98 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1743 4.13598C33.7381 8.74304 30.204 32.171 27.1743 32.9153C21.1161 34.4038 2.94035 37.3812 1.93066 19.5181C0.925251 1.73072 17.4085 -2.71855 27.1743 4.13598Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 18.0731C25.8867 24.1482 24.9619 28.0731 18.8867 28.0731C12.8116 28.0731 11.8867 24.1482 11.8867 18.0731C11.8867 11.9979 12.8116 8.07308 18.8867 8.07308C24.9619 8.07308 25.8867 11.9979 25.8867 18.0731Z",
    className: "Eyes"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88703 19.573C0.887026 12.0696 6.8866 -1.42693 21.8866 1.57307C13.3868 -2.92692 -6.11327 3.07308 1.88703 19.573Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5991 4.20903C64.0353 8.8161 67.5694 32.2441 70.5991 32.9884C76.6573 34.4769 94.8331 37.4542 95.8428 19.5912C96.8482 1.80378 80.3649 -2.64549 70.5991 4.20903Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8867 18.1461C71.8867 24.2213 72.8116 28.1461 78.8867 28.1461C84.9619 28.1461 85.8867 24.2213 85.8867 18.1461C85.8867 12.071 84.9619 8.14614 78.8867 8.14614C72.8116 8.14614 71.8867 12.071 71.8867 18.1461Z",
    className: "Eyes"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8864 19.6461C96.8864 12.1427 90.8868 -1.35387 75.8868 1.64613C84.3866 -2.85386 103.887 3.14614 95.8864 19.6461Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesC);
export default __webpack_public_path__ + "static/media/Eyes C.f456406d5b5b6e6859d66bd141a56a5d.svg";
export { ForwardRef as ReactComponent };